import React from 'react'

const HeaderRightArea: React.FC<{
  className?: string
}> = ({ className, children }) => {
  return (
    <div className={className}>
      <div className="ml-4">{children}</div>
    </div>
  )
}

export { HeaderRightArea }
